<template>
  <div class="ly-card news-briefed-detail">
    <ly-form :defaultFormItem="defaultFormItem" :formConfig="formConfig" :formKeys="formKeys" ref="lyFormBriefed">
      <template v-slot:surface_plot="{ formData }">
        <img :src="`${baseUrl}/${formData.surface_plot}`" v-if="formData.surface_plot" width="400px" />
        <upload
          @successCBK="value => mediaChange('surface_plot', value, formData)"
          tips="尺寸：233*139"
          accept=".jpg, .jpeg, .png, .gif, .bmp"
        />
      </template>
      <template v-slot:content="{ formData }">
        <tinymce ref="tinymce" v-model="formData.content" :height="300" />
      </template>
      <template v-slot:banner="{ formData }">
        <el-checkbox v-model="formData.is_show">激活</el-checkbox>
        <img :src="`${baseUrl}/${formData.banner}`" v-if="formData.is_show && formData.banner" width="400px" />
        <upload
          v-if="formData.is_show"
          tips="尺寸：690*300"
          @successCBK="value => mediaChange('banner', value, formData)"
          accept=".jpg, .jpeg, .png, .gif, .bmp"
        />
      </template>
      <template v-slot:is_show></template>
    </ly-form>
    <div class="buttom">
      <el-button @click.native="back">返 回</el-button>
      <el-button @click.native="addSubmit" type="primary">保 存</el-button>
    </div>
  </div>
</template>
<script>
import { Checkbox } from 'element-ui';
import { frontInf } from '@/api';
import Tinymce from '@/components/Tinymce';
import LyForm from '@/components/LyForm';
import Upload from '@/components/Upload';
import { newsFormItem } from '@/utils/formConfig';

export default {
  name: 'newBriefedDetail',
  components: {
    Tinymce,
    Upload,
    LyForm,
    ElCheckbox: Checkbox
  },
  data() {
    return {
      rowItem: {},
      defaultFormItem: {
        is_use: true
      },
      baseUrl: '',
      formKeys: {},
      formConfig: {
        'label-width': '120px',
        'label-position': 'left',
        ref: 'ly-form',
        itemSpan: 24
      }
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      // 获取多媒体信息地址
      this.$store.dispatch('app/getOssUrl').then(url => {
        if (url) this.baseUrl = url;
      });

      frontInf.informationType().then(res => {
        if (res && res.data) {
          newsFormItem.info_type.options.select = res.data;
          this.formKeys = newsFormItem;
        }
      });
      if (this.$route.params.id && this.$route.params.id !== '-1') {
        frontInf
          .controlInformation({
            id: this.$route.params.id
          })
          .then(res => {
            if (res && res.data) {
              this.rowItem = res.data;
              this.defaultFormItem = { ...res.data };
            }
          });
      }
    },
    async addSubmit() {
      const { data, valid } = await this.$refs.lyFormBriefed.getFormData();
      data.is_show = !!data.is_show;
      if (!valid) return;
      if (this.$route.params.id !== '-1') {
        // 修改
        const res = await frontInf.controlInformation({
          id: this.$route.params.id,
          params: data,
          methold: 'put'
        });
        if (res) {
          this.$message.success(res.msg || '修改成功！');
          this.back();
        }
      } else {
        // 新增
        const res = await frontInf.addInformation({
          params: data
        });
        if (res) {
          this.$message.success(res.msg || '新增成功！');
          this.back();
        }
      }
    },
    mediaChange(key, value, formData) {
      if (value && value.length) {
        // eslint-disable-next-line no-param-reassign
        formData[key] = value[0].url;
      }
    },
    reset() {
      this.$refs.tinymce.setContent('');
      this.defaultFormItem = {
        is_use: true
      };
      this.$refs.lyFormBriefed.resetFields();
    },
    back() {
      this.$store.dispatch('tagsView/delView', this.$route).then(() => {
        this.$router.replace({ path: `/${this.$route.params.user_id}/news/briefed` });
      });
    }
  }
};
</script>
<style lang="less">
.news-briefed-detail {
  .ly-form .el-input__inner {
    width: 220px;
  }
  .content-width-full {
    .el-form-item {
      width: 100%;
      .el-form-item__content {
        width: 100%;
      }
    }
  }
  .height-0 {
    height: 0;
    overflow: hidden;
  }
  .el-textarea__inner {
    width: 400px;
  }
}
</style>
